import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelCatSinterklaas: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" height="170" width="255" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="m32.54 115.55 75.5 39.7v2.73l132.64-25.14v-2.73l-75.5-39.7-132.64 25.14Z" fill="#BB9260" />
    <path
      d="m76.91 163.87 31.09-5.89-75.5-39.7L2 124.1l74.91 39.77Z"
      fill="url(#parcel_cat_sinterklaas_paint0_linear)"
    />
    <path
      d="m238.61 128.98-3.94-2-133 25-3.43-1.8 133-25-3.88-2-133 25-3.43-1.8 133-25-3.93-2.13-133 25-3.43-1.81 133-25-3.88-2-133 25-3.43-1.8 133-25-3.88-2-133 25-3.38-1.92 133-25-3.88-2-133 25-3.44-1.81 133-25-3.88-2-133 25-3.43-1.8 133-25-3.88-2-133 25-3.49-1.93 133-25-3.89-2-133 25-3.44-1.8 133-25-3.89-2-133 25-3.3-1.74v2.73L79.7 143.2l7.23 3.8v.06h.08l7.17 3.77v.1h.12l13.7 7.05v-2.73l-2.47-1.3 133.08-24.97Z"
      fill="#9E7548"
    />
    <path
      opacity=".5"
      d="m139.63 122.11 10-2-17-8.4-10 1.9 17 8.5Z"
      fill="url(#parcel_cat_sinterklaas_paint1_linear)"
    />
    <path d="m149.63 93.31 29.8-5.4-17-8.4-29.8 5.3 17 8.5Z" fill="#FDDE84" />
    <path opacity=".4" d="m142.33 89.61 29.8-5.3-2.8-1.4-29.9 5.27 2.9 1.43Z" fill="#AA7B33" />
    <path d="M149.63 93.31v26.8l-17-8.4v-26.9l17 8.5Z" fill="#C39000" />
    <path opacity=".4" d="M142.33 89.61v5.9l-2.9-1.5v-5.83l2.9 1.43Z" fill="#AA7B33" />
    <path d="M149.63 93.31v26.8l29.8-5.4v-26.8l-29.8 5.4Z" fill="#FCCE09" />
    <path d="m142.33 116.51-2.6-1.3-.3-27 2.9 1.4v26.9Z" fill="#7F0522" />
    <path d="m169.33 82.91-29.9 5.27 2.9 1.4 29.8-5.3-2.8-1.37Z" fill="#D2002E" />
    <path d="m162.83 117.71 3.1-.5.2-26.9-3.3.6v26.8Z" fill="#AF0527" />
    <path d="m149.83 81.71 16.3 8.6-3.3.6-16-8.6 3-.6Z" fill="#D2002E" />
    <path
      d="m154.23 85.71-7.9-.5c-1.7-.1-2.4.8-2.4 1.8a2.51 2.51 0 0 0 1.6 2c.8.5 4.3 2.8 4.3 2.8l6.8-4.5-2.4-1.6Z"
      fill="#D2002E"
    />
    <path d="M156.63 87.18s-3.1.6-4.7 1-3.1.7-2.8 2.5c.3 1.8 2.3 1.1 3.4.3.9-.97 4.1-3.8 4.1-3.8Z" fill="#AF0527" />
    <path d="M155 85.61s1.8-4.7 2.2-5.8c.4-1.1 1.2-2.3 2.3-1.8 1.1.5 6 3.1 6 3.1l-8.3 5.9-2.2-1.4Z" fill="#D2002E" />
    <path
      d="M157.13 87.01s4.7-4.4 5.4-5c.7-.6 3-1.9 3.1-.4.1 1.5-1.1 2-2.5 2.8-1.4.8-6 2.6-6 2.6ZM147.13 85.71l7.3.3.8 1-5.1 1.1 3.7-1.2-2.4-.1 1.9-.4-6.2-.7ZM155.83 85.31l2-4.7-1.3 4.2.9-1.1-.4 1.2s1.4-1.8 1.4-1.7l-1 2 3.9-3.2-4.3 4-1.2-.7Z"
      fill="#AF0527"
    />
    <path
      d="M157.23 85.51a.83.83 0 0 1 0 1.6 3.418 3.418 0 0 1-2.8 0 .83.83 0 0 1 0-1.6 2.802 2.802 0 0 1 2.8 0Z"
      fill="#D2002E"
    />
    <path
      d="M157.43 86.81a3.418 3.418 0 0 1-2.8 0c-.5-.3-.7-.7-.5-1.1-.4.4-.3 1 .3 1.4a3.418 3.418 0 0 0 2.8 0 .829.829 0 0 0 .5-.5c0 .1-.1.1-.3.2Z"
      fill="#AF0527"
    />
    <path opacity=".05" d="M144.73 88.01v.8l6.8-1v-.9l-6.8 1.1Z" fill="#000" />
    <path
      opacity=".5"
      d="m185.09 136.36 30.09-6.31-25.42-12.79-30.23 6.32 25.56 12.78Z"
      fill="url(#parcel_cat_sinterklaas_paint2_linear)"
    />
    <path
      opacity=".5"
      d="m185.09 136.36 30.09-6.31-25.42-12.79-30.23 6.32 25.56 12.78Z"
      fill="url(#parcel_cat_sinterklaas_paint3_linear)"
    />
    <path d="M195.47 69.18c-.15 0-.3.15-.45.15-.45.15-.75-.45-.75-.45s.3-.15.45-.3c.75-.35.75.6.75.6Z" fill="#DFA718" />
    <path
      d="M196.53 68.83c-.16 0-.31.15-.46.15-.45.15-.75-.6-.75-.6.15 0 .3-.15.45-.15.76-.3.76.6.76.6Z"
      fill="#DFA718"
    />
    <path
      d="M197.43 68.53c-.15 0-.3.15-.45.15-.45.15-.61-.6-.61-.6.16 0 .31-.15.46-.15.75-.15.6.6.6.6Z"
      fill="#DFA718"
    />
    <path
      d="M198.48 68.38a.548.548 0 0 0-.45.15c-.45.15-.6-.6-.6-.6a.553.553 0 0 0 .45-.15c.75-.3.6.6.6.6Z"
      fill="#DFA718"
    />
    <path
      d="M199.38 68.23h-.45c-.45 0-.6-.6-.6-.6h.45c.9-.15.6.6.6.6ZM200.44 68.08H200c-.45 0-.6-.75-.45-.75h.45c.74 0 .44.75.44.75Z"
      fill="#DFA718"
    />
    <path d="M201.49 68.23H201c-.45 0-.45-.75-.45-.75h.45c.79 0 .49.75.49.75Z" fill="#DFA718" />
    <path
      d="M202.39 68.23h-.45c-.45 0-.45-.75-.45-.75h.45c.9.15.45.75.45.75ZM203.44 68.53a.55.55 0 0 1-.45-.15c-.45-.15-.3-.75-.3-.75a.553.553 0 0 1 .45.15c.76 0 .3.75.3.75Z"
      fill="#DFA718"
    />
    <path
      d="M204.35 68.68c-.15 0-.3-.15-.45-.15-.46-.15-.31-.9-.31-.9.15 0 .31.15.46.15.95.3.3.9.3.9ZM205.4 69.18c-.15 0-.3-.15-.45-.15-.45-.15-.15-.9-.15-.9s.3.15.45.15c.6.25.15.9.15.9Z"
      fill="#DFA718"
    />
    <path
      d="M206.3 69.58c-.15 0-.3-.15-.45-.15-.45-.15-.15-.9-.15-.9.15 0 .3.15.45.15.75.3.15.9.15.9Z"
      fill="#DFA718"
    />
    <path
      d="M206 67.48s-8-1.66-9.93-12.64c4.52-1 4.37.45 4.37.45l-.44-2.55s26.78-4.36 31.29 10.38c-6.92.75-14.74 6.31-14.74 6.31s22.41 32.64 8.12 53.4c-5 7.07-6.77 8.87-28.43 7.07-53.71-4.67 9.76-62.42 9.76-62.42Z"
      fill="#C18752"
    />
    <path
      d="M200.74 55.75s-1.66 11.13 8.87 12.33a31 31 0 0 1-8.87-12.33ZM217 52.74a49.536 49.536 0 0 0-11.3-.56c-.15 6.61 5.11 15.19 5.11 15.19A20.356 20.356 0 0 1 217 52.74ZM207.35 69.28s-10.52 4.82-11.13 14.9c-.45 11.27 11.13-14.9 11.13-14.9Z"
      fill="#A8692F"
    />
    <path
      d="M205.55 68.68c-.15-.15-.3-.15-.45-.3-.15-.15-.15-.45-.15-.6a.462.462 0 0 0 .15-.3c.15.15.3.15.45.3a.527.527 0 0 1 .183.707.527.527 0 0 1-.183.193Z"
      fill="#DFA718"
    />
    <path
      d="M206.45 69.18c-.15-.15-.3-.15-.45-.3-.45-.3 0-.9-.15-.9.15.15.3.15.45.3.75.4.15.9.15.9ZM207.5 69.58c-.15 0-.3-.15-.45-.15-.45-.15-.15-.9-.15-.9.15 0 .3.15.45.15.76.3.15.9.15.9Z"
      fill="#DFA718"
    />
    <path d="M208.71 69.88c-.15 0-.3-.15-.6-.15-.61-.15-.3-.9-.3-.9.15 0 .3.15.45.15.74.3.45.9.45.9Z" fill="#DFA718" />
    <path
      d="M209.76 70.18c-.211.006-.42-.05-.6-.16-.6-.15-.3-.9-.3-.9a.551.551 0 0 1 .45.15c.75.16.45.91.45.91Z"
      fill="#DFA718"
    />
    <path d="M210.81 70.18h-.6c-.6 0-.45-.76-.45-.76h.45c.9.16.6.76.6.76Z" fill="#DFA718" />
    <path d="M212 70.34h-.6c-.61 0-.46-.76-.46-.76h.61c.77 0 .45.76.45.76Z" fill="#DFA718" />
    <path d="M213.07 70.34h-.6c-.6 0-.45-.76-.45-.76h.6c.75-.15.45.6.45.76Z" fill="#DFA718" />
    <path d="M214.27 70.18h-.6c-.6 0-.6-.76-.6-.76h.6c.75.01.6.76.6.76Z" fill="#DFA718" />
    <path d="m215.33 70.03-.61.16c-.6.15-.6-.61-.6-.61h.45c.91-.3.76.45.76.45Z" fill="#DFA718" />
    <path
      d="m216.38 69.73-.6.15c-.6.15-.6-.6-.6-.6l.45-.15c.9-.15.75.6.75.6ZM206.45 68.98c0-.15-.15-.3-.15-.45-.15-.3.15-.45.3-.45a.461.461 0 0 1 .3-.15.552.552 0 0 0 .15.45c.15.3 0 .45-.15.6h-.45Z"
      fill="#DFA718"
    />
    <path
      d="M206.9 69.88c-.15-.15-.15-.3-.3-.45-.3-.45.45-.75.45-.75s.15.3.15.45c.15.3.15.45 0 .6a.462.462 0 0 1-.3.15ZM207.66 70.79c-.16-.15-.31-.3-.31-.45-.3-.46.31-.76.31-.76.15.15.15.3.3.3.15.31.15.46 0 .61l-.3.3ZM208.56 71.39c-.15-.15-.3-.15-.45-.3-.45-.3.15-.9.15-.9.15.15.3.15.3.3a.367.367 0 0 1 .237.26.359.359 0 0 1-.001.18.363.363 0 0 1-.086.16c0 .3-.15.3-.15.3ZM209.46 71.99c-.15 0-.3-.15-.45-.15-.45-.3 0-.9 0-.9a.548.548 0 0 0 .45.15c.3.15.3.3.3.6l-.3.3Z"
      fill="#DFA718"
    />
    <path
      d="M210.51 72.18a.553.553 0 0 1-.45-.15c-.45-.15-.3-.9-.3-.9.15 0 .3.15.45.15a.48.48 0 0 1 .45.45.663.663 0 0 1-.15.45Z"
      fill="#DFA718"
    />
    <path
      d="M211.57 72.29H211c-.6 0-.45-.75-.45-.75h.45c.87 0 .57.75.57.75ZM212.62 72.18h-.45c-.45 0-.45-.75-.45-.75h.45c.6-.04.45.75.45.75Z"
      fill="#DFA718"
    />
    <path d="M213.67 71.99a.55.55 0 0 0-.45.15c-.45.15-.6-.6-.6-.6h.45c.75-.3.6.45.6.45Z" fill="#DFA718" />
    <path
      d="M214.72 71.84c-.15 0-.3.15-.45.15-.45.15-.6-.6-.6-.6a.553.553 0 0 0 .45-.15c.6-.3.6.45.6.6ZM215.78 71.39c-.15 0-.3.15-.45.15-.46.15-.61-.6-.61-.6l.46-.15c.6-.15.6.6.6.6Z"
      fill="#DFA718"
    />
    <path d="m216.68 71.09-.45.15c-.45.15-.75-.6-.75-.6l.45-.15a.591.591 0 0 1 .75.6Z" fill="#DFA718" />
    <path
      d="M203.9 130.35c17.59-35.8-13.09-41.36-17-42-12.94 17-22.56 38.66 9.17 41.37 2.598.342 5.211.552 7.83.63Z"
      fill="#A8692F"
    />
    <path
      opacity=".5"
      d="m148.89 133.6 12.6-2.62-15.08-7.86-12.61 2.62 15.09 7.86Z"
      fill="url(#parcel_cat_sinterklaas_paint4_linear)"
    />
    <path d="m161.49 120.5 14.68-2.62-15.09-7.85-14.67 2.61 15.08 7.86Z" fill="#FDDE84" />
    <path d="M161.49 120.5v10.68l-15.08-8.08v-10.46l15.08 7.86Z" fill="#C39000" />
    <path d="M161.49 120.5v10.68l14.68-2.84v-10.46l-14.68 2.62Z" fill="#FCCE09" />
    <path d="m155.09 127.71-2.28-1.09-.2-10.7 2.68 1.31-.2 10.48Z" fill="#0E248C" />
    <path d="m167.07 113.08-14.46 2.84 2.68 1.31 14.26-2.84-2.48-1.31Z" fill="#4B67BF" />
    <path d="m167.69 129.89 2.9-.44v-10.47l-3.1.43.2 10.48Z" fill="#0E248C" />
    <path d="m156.12 110.9 14.47 8.08-3.1.43-14.26-8.08 2.89-.43Z" fill="#4B67BF" />
    <path
      d="M159.63 114.39s-5.78-.44-7.23-.44c-1.45 0-2.27.88-2.27 1.75s.82 1.53 1.44 2c.83.43 3.93 2.62 3.93 2.62l6.2-4.37-2.07-1.56Z"
      fill="#4B67BF"
    />
    <path
      d="M161.91 115.7s-2.9.66-4.34.87c-1.44.21-2.9.66-2.48 2.41.2 1.74 2.06 1.09 3.1.21.81-.65 3.72-3.49 3.72-3.49Z"
      fill="#0E248C"
    />
    <path
      d="M160.25 114.18s1.66-4.58 2.07-5.67c.41-1.09 1-2.19 2.07-1.75 1 .66 5.58 3.06 5.58 3.06l-7.65 5.67-2.07-1.31Z"
      fill="#4B67BF"
    />
    <path
      d="M162.32 115.48s4.34-4.14 5-4.8c.66-.66 2.69-1.75 2.89-.44 0 1.53-1 2-2.27 2.62-1.49.88-5.62 2.62-5.62 2.62ZM153 114.39l6.82.22.62.87-4.55 1.09 3.52-1.09h-2.28l1.66-.43-5.79-.66ZM161.08 113.95l1.86-4.58-1.24 4.15.83-1.09-.42 1.09 1.24-1.75-.82 2 3.47-3.09-3.93 3.93-.99-.66Z"
      fill="#0E248C"
    />
    <path
      d="M162.53 114.18a.853.853 0 0 1 .467.765.864.864 0 0 1-.467.765 2.496 2.496 0 0 1-2.48 0 .86.86 0 0 1 0-1.53 2.541 2.541 0 0 1 2.48 0Z"
      fill="#4B67BF"
    />
    <path
      d="M162.53 115.48a2.496 2.496 0 0 1-2.48 0 .81.81 0 0 1-.42-1.09c-.41.44-.2.87.21 1.31a2.496 2.496 0 0 0 2.48 0c.21-.22.41-.22.41-.44l-.2.22Z"
      fill="#0E248C"
    />
    <path
      d="M133.86 113.65c3.07 3.9-.92 7.89-6.35 10.86-5.43 2.97-12.09 2.87-13.63 0-.92-1.74.1-4.3 2.05-6.25 2.56-2.66 5.43-3.28 7.58-4.71 1.95-1.33 3.38-2.77 4.71-3 2.26-.59 4.1.95 5.64 3.1ZM98.31 70.42l6.86 47.64-20.49 2.56c-.576.083-1.158.117-1.74.1-6.66.31-6.66.31-7.58.41-4.3.1-8.81-.1-12.5-.1l-4.92-.51c-2.56-.41-5.84-.82-7.78-2.46-1.74-1.44-2.67-5.13-3.59-7.38-3.69-9.42-3.07-20.08.51-29.61.21-.51.41-1 .62-1.64a24.3 24.3 0 0 1 19-15.47h.31a24.63 24.63 0 0 1 16.19 2.87l.51.31c2.15 1.23 4.2 2.77 6.56 3.28 2.61.61 5.48.2 8.04 0Z"
      fill="#C8C9C8"
    />
    <path
      d="M64.19 112.52a11.873 11.873 0 0 0-7.07.52c-4 1.64-7.78 4.91-7 5.53 1.94 1.64 5.12 2 7.78 2.46l4.92.51c3.69 0 8.2.2 12.5.1.92 0 .92 0 7.48-.41.61 0 1.13-.1 1.74-.1l15.61-.95 10.15-1.64 3.17-3.89-12.4 3.27.52 1.54-13.32-17.28-5 6.45a32.444 32.444 0 0 1-8 5.43c-1.85.72-4 1-7.58-.51a8.613 8.613 0 0 0-1.54-.51l-1.96-.52ZM130.68 110.89c.62 1.12-4.51 5-7.89 8.5-3.17 3.28-6.76 2.46-7.58.61-.82-1.85.92-3.27 5.33-5.22 5.22-2.25 9.46-5.23 10.14-3.89Z"
      fill="#B8B8B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M78.55 64.77a24.999 24.999 0 0 0-11.49-.81h-.31a24.31 24.31 0 0 0-18.69 14.56c.58 4.57 5.3 7.68 11.93 6.34C71 82.64 77.39 68.5 78.55 64.77Z"
      fill="#B8B8B8"
    />
    <path
      d="M71.26 106.89c4.53 0 8.2-3 8.2-6.76s-3.67-6.76-8.2-6.76c-4.53 0-8.19 3-8.19 6.76s3.67 6.76 8.19 6.76ZM129.86 78.18l-.41-9.23c.31-.2.93-.3.93 1.75l-.52 7.48ZM102.2 74.52l2.25-1.54-3.79-4.1c-1.12-.92-1.84-.2-1.84-.2a2.582 2.582 0 0 1 2.25 2.15c.051.245.121.486.21.72l.92 2.97Z"
      fill="#B8B8B8"
    />
    <path
      d="M48 103.26s-14.14 4.21-15 18.65c0 0-1.13 14 17.41 16.9 0 0 18.34 4.1 19.78-5.32 0 0 1.12-11-6.87-9-3.28.51-9.32.82-11.88-.41 0 0-3.89-2.76.82-7.48L48 103.26Z"
      fill="#C8C9C8"
    />
    <path
      d="M55.68 113.82s-12.19 1.23-9.83 8.19c0 0 1 2.56 7.37 2.67a5.434 5.434 0 0 1-2.15-.92c-.92-.93-2.15-3.18.51-6.46a28.932 28.932 0 0 1 4.1-3.48Z"
      fill="#B8B8B8"
    />
    <path
      d="M108.42 123.45c.69-3.27-3.72-7-9.86-8.28-6.14-1.28-11.69.28-12.39 3.54-.7 3.26 3.73 7 9.87 8.28 6.14 1.28 11.68-.28 12.38-3.54Z"
      fill="#C8C9C8"
    />
    <path
      d="M107.73 121.64c-.71 1.74-4.61 2.05-7.78-1-2.87-2.77-4.72-5-4.41-5.74.1-.2 2.15-.72 6.25 1a15.907 15.907 0 0 1 3.28 1.74c1.93 1.65 3.18 2.77 2.66 4Z"
      fill="#B8B8B8"
    />
    <path d="m131.3 81.99-8-8 6.7-7.81c1.75-1.13 2.16.51 2.16 3.17l-.86 12.64Z" fill="#E4E4E4" />
    <path d="m129.86 78.18-4.4-4.72 3.58-4.2c.82-.72 1.33-.61 1.33 1.44l-.51 7.48Z" fill="#C8C8C8" />
    <path
      d="M111.52 118.67c14.09 0 25.51-11.74 25.51-26.22 0-14.48-11.42-26.27-25.51-26.27C97.43 66.18 86 77.96 86 92.45s11.44 26.22 25.52 26.22Z"
      fill="#E4E4E4"
    />
    <path d="m96.26 78.1 9.53-5.92-5.74-6.25c-1.74-1.54-3.48-.72-3.69 1.64l-.1 10.53Z" fill="#E4E4E4" />
    <path
      d="m98.21 76.87 6.25-3.89-3.8-4.1c-1.12-.92-2.25-.41-2.35 1l-.1 6.99ZM131.23 81.06c1.61-3.24-1-7.83-5.91-10.23-4.91-2.4-10.12-1.73-11.72 1.52-1.6 3.25 1 7.83 5.91 10.24s10.12 1.72 11.72-1.53ZM124.54 97.67c.3 0 .61-.1.82-.1h1.94c.41 0 .82.1 1.23.1.41 0 .72.1 1 .21l1 .2.1-.41-1-.2c-.31-.11-.72-.11-1-.21h-.2c-.31 0-.72-.1-1-.1h-1.94c-.41 0-.82.1-1.23.1l-.72.1a3.056 3.056 0 0 0-.92.21l-.31.1a5.918 5.918 0 0 0-1.23.41l-.41.2.11.21v.2h1.43c.62.06 1.235.163 1.84.31.41.1.72.1 1.13.21l.41.1 1.84.61h.11c.629.235 1.244.509 1.84.82l.72.41.2-.41-.92-.51c-.51-.2-1-.51-1.54-.72l-.41-.2-1.84-.62-.31-.1c-.41-.1-.92-.2-1.33-.31l-.72-.1-.92-.1.82-.31 1.41-.1ZM109 98.08c-.3 0-.61-.1-.82-.1h-1.98c-.41 0-.82.1-1.23.1-.41 0-.72.1-1 .2l-2 .72-.2-.41 2.15-.72c.31-.1.72-.1 1-.2h.2c.31 0 .72-.1 1-.1h2c.41 0 .82.1 1.23.1l.72.1c.316.017.628.088.92.21l.31.1c.425.087.838.224 1.23.41l.41.2-.11.21v.2h-1.43c-.62.06-1.235.163-1.84.31-.41.1-.72.1-1.13.21l-.41.1-1.85.61H106c-.629.235-1.244.509-1.84.82l-.82.52-.21-.41 1-.62c.51-.2 1-.51 1.54-.72l.4-.2 1.85-.62.31-.1c.41-.1.92-.2 1.33-.31l.72-.1.92-.1-.8-.31-1.4-.1Z"
      fill="#C8C8C8"
    />
    <path
      d="M124.53 99.92c-.2-.1-.4 0-.4.21a3.814 3.814 0 0 1-5.394 1.826 3.803 3.803 0 0 1-1.476-1.516.098.098 0 0 1-.041-.009.078.078 0 0 1-.033-.024.082.082 0 0 1-.021-.036c-.005-.013-.006-.027-.005-.041a.099.099 0 0 0-.1-.1h-.21a.105.105 0 0 1-.029.071.103.103 0 0 1-.071.029.09.09 0 0 0-.074.033.082.082 0 0 0-.021.036c-.005.013-.006.027-.005.041 0 .1-.62 1.74-3.08 2.25a3.997 3.997 0 0 1-4.61-2c-.1-.2-.3-.2-.51-.1-.21.1-.2.31-.1.51a4.803 4.803 0 0 0 4.1 2.36c.413.016.826-.017 1.23-.1a5.005 5.005 0 0 0 3.38-2.15 4.272 4.272 0 0 0 3.48 1.97 3.51 3.51 0 0 0 1-.1 3.997 3.997 0 0 0 3.28-2.77.557.557 0 0 0-.29-.39Z"
      fill="#8E8E8E"
    />
    <path d="M113.47 96.75H120l-3 3.69" fill="#D20612" />
    <path
      d="M108 91.18a1.65 1.65 0 0 1-1.64 1.74 1.71 1.71 0 0 1-1.6-1.74 1.63 1.63 0 0 1 .373-1.32 1.635 1.635 0 0 1 1.247-.575 1.637 1.637 0 0 1 1.578 1.194c.065.228.079.467.042.701ZM126.58 91.18a1.639 1.639 0 0 1-1.64 1.74 1.699 1.699 0 0 1-1.63-1.74 1.631 1.631 0 0 1 .978-1.63 1.64 1.64 0 0 1 2.292 1.63Z"
      fill="#000"
    />
    <path
      d="M88.88 67.25c-.53-3.7-1.43-7.87-1.49-10.58.33-6.88 1.31-15.54 1.75-15.9 1.23-.27 11.27 9.3 12.1 10.75 1.44 1.88-3.71 24.78-12.36 15.73Z"
      fill="#90191C"
    />
    <path
      d="M96.68 35.06c1.62-.88 17.48 17.78 19.5 21.12.33 1.57 2.38 12.3 2.66 13.6a20.129 20.129 0 0 1-9.47 6.4c-7 2-17 1.46-17 1.46-.78-1.2-4.51-10.21-4.32-10.52-.333-3.5-.487-7.014-.46-10.53.32 2.66 1.21 6.83 1.51 7 .36.47.91.63 2.1-3.44.46-1.46 4.27-24.62 5.44-25.15"
      fill="#EB2028"
    />
    <path
      d="M98.17 37.18c2.62 3.79 8 15.46 10.13 23.16 1.19 4.38 3.79 15.27 3.56 14.23l-2.22.47s-2-9.12-3.56-14.22c-3.17-9.95-8.22-20.31-8.86-22.08-.83-1.45 1-1.56 1-1.56"
      fill="#FCD811"
    />
    <path d="M113.6 56.23s-9.9 6.75-22 8c-.25.05-.93 2.92-.93 2.92s15.93-1.51 24.43-8.78l-1.5-2.14Z" fill="#FCD811" />
    <path
      d="M109.91 69.18a.513.513 0 0 0-.402-.394.512.512 0 0 0-.606.498.504.504 0 0 0 .306.471.51.51 0 0 0 .292.035.52.52 0 0 0 .41-.61ZM108.82 65.18a.502.502 0 0 0-.685-.341.494.494 0 0 0-.301.459.504.504 0 0 0 .302.458c.089.039.188.05.284.034a.522.522 0 0 0 .325-.223c.075-.114.102-.253.075-.387ZM107.64 61.23a.524.524 0 0 0-.387-.43.522.522 0 0 0-.203-.01.512.512 0 0 0-.412.406.5.5 0 0 0 .002.204.53.53 0 0 0 .59.44.52.52 0 0 0 .41-.61ZM106.47 56.94a.513.513 0 0 0-.403-.393.511.511 0 1 0-.007 1.003.52.52 0 0 0 .41-.61ZM105.18 53.26a.523.523 0 0 0-.59-.44.508.508 0 0 0-.328.215.5.5 0 0 0-.072.385.532.532 0 0 0 .59.45.521.521 0 0 0 .325-.223c.075-.114.102-.253.075-.387ZM103.75 49.86a.502.502 0 0 0-.685-.342.494.494 0 0 0-.301.46.504.504 0 0 0 .301.458c.09.039.189.05.285.034a.502.502 0 0 0 .328-.221.492.492 0 0 0 .075-.188.49.49 0 0 0-.003-.201ZM102.34 46.7a.502.502 0 0 0-.685-.341.5.5 0 0 0 .285.95.521.521 0 0 0 .4-.61ZM100.84 43.46a.504.504 0 0 0-.192-.368.51.51 0 0 0-.808.538.542.542 0 0 0 .59.44.52.52 0 0 0 .41-.61ZM104.16 62.55a.524.524 0 0 0-.387-.43.52.52 0 0 0-.203-.01.532.532 0 0 0-.446.391.528.528 0 0 0 .196.56.53.53 0 0 0 .84-.511ZM101 63.41a.523.523 0 0 0-.59-.44.515.515 0 0 0-.328.22.51.51 0 0 0-.072.39.507.507 0 1 0 1-.17H101ZM97.07 64.56a.52.52 0 0 0-.59-.44.512.512 0 0 0-.41.61.53.53 0 0 0 .59.44.52.52 0 0 0 .41-.61ZM93.61 65.24a.52.52 0 0 0-.59-.44.51.51 0 0 0-.4.6.53.53 0 0 0 .59.45.52.52 0 0 0 .4-.61ZM110.67 59.63a.513.513 0 0 0-.402-.393.512.512 0 0 0-.606.497.504.504 0 0 0 .306.471.51.51 0 0 0 .292.035.52.52 0 0 0 .41-.61ZM113.32 58.02a.523.523 0 0 0-.59-.44.533.533 0 0 0-.446.39.536.536 0 0 0 .196.56.53.53 0 0 0 .84-.51ZM97.2 37.87a.507.507 0 1 0 1-.17"
      fill="#F4A621"
    />
    <path
      d="M97.35 38.18c-.16 1.67-.83 4.54-1.26 7.35-1 5.12-1.76 11-2 12.16-.33.88-.49 2.55-1 4a21.294 21.294 0 0 1-2 4c.05.26.33 1.56 1.25 4.64.75 2.29 1.55 4.84 2.08 6.09.11.52-.08.83-.33.89h-.25c-.19.31-.43.37-.54-.15-.49-1.21-1.3-3.98-2.16-6.58a19.361 19.361 0 0 1-1-3.33c-.28-1.3-.45-2.09 0-2.45 1.75-1.47 2.39-5.69 2.8-7.41l-.04-.21c.27-1.15 1.07-7 2-12.16.7-4 1.26-7.35 1.53-8.5M97.4 36c.3.21.85.36 6.77 7.54 3.42 3.9 7 8.32 9 10.61a14.88 14.88 0 0 1 1.44 1.87v.26c.64 1.77 2.1 11 2.47 13.91.11.52-.08.83-.63.68-.24.05-.6-.42-.66-.68-.31-2.65-1.91-11.3-2.35-13.39-.31-.2-.72-.93-1.38-1.61-2-2.29-5.57-6.71-8.68-10.4-1.73-2.08-3.11-3.69-4.43-5a16.769 16.769 0 0 0-1.6-1.61"
      fill="#FCD811"
    />
    <path d="M110.91 72.92a.53.53 0 1 0-1.045.17.53.53 0 0 0 1.045-.17Z" fill="#F4A621" />
    <path
      d="m118.2 68.05.45 2.08c-4.2 6.9-15.6 9.07-26.49 7.59a15.1 15.1 0 0 1-.75-2.29c8 1.28 14.29.48 18.81-1.31a23.17 23.17 0 0 0 7.98-6.07Z"
      fill="#FCD811"
    />
    <path d="M99.37 40.24a.53.53 0 1 0-1.047.171.53.53 0 0 0 1.047-.171Z" fill="#F4A621" />
    <defs>
      <linearGradient
        id="parcel_cat_sinterklaas_paint0_linear"
        x1="49.74"
        y1="151.16"
        x2="62.35"
        y2="126.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".6" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
      <linearGradient
        id="parcel_cat_sinterklaas_paint1_linear"
        x1="134.65"
        y1="119.76"
        x2="137.6"
        y2="113.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".51" stopColor="#181816" stopOpacity=".36" />
        <stop offset=".82" stopColor="#080807" stopOpacity=".82" />
        <stop offset=".93" />
      </linearGradient>
      <linearGradient
        id="parcel_cat_sinterklaas_paint2_linear"
        x1="10229.4"
        y1="653.779"
        x2="10300.4"
        y2="1060.35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".51" stopColor="#181816" stopOpacity=".36" />
        <stop offset=".82" stopColor="#080807" stopOpacity=".82" />
        <stop offset=".93" />
      </linearGradient>
      <linearGradient
        id="parcel_cat_sinterklaas_paint3_linear"
        x1="10229.4"
        y1="653.779"
        x2="10300.4"
        y2="1060.35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".51" stopColor="#181816" stopOpacity=".36" />
        <stop offset=".82" stopColor="#080807" stopOpacity=".82" />
        <stop offset=".93" />
      </linearGradient>
      <linearGradient
        id="parcel_cat_sinterklaas_paint4_linear"
        x1="4111.75"
        y1="453.239"
        x2="4131.44"
        y2="549.923"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".51" stopColor="#181816" stopOpacity=".36" />
        <stop offset=".82" stopColor="#080807" stopOpacity=".82" />
        <stop offset=".93" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
